import { useState } from 'react'

import { AppointmentFormModal } from '../../Appointment'
import Button from '../../Button'
import { Container } from '../Container'

function AppointmentForms() {
  const [isOpen, setOpen] = useState(false)

  function handleOpen() {
    setOpen(true)
  }

  function handleClose() {
    setOpen(false)
  }

  return (
    <Container label='Appointment form on the mock client'>
      <Button.Contained text='Open the form' onClick={handleOpen} />
      {isOpen ? <AppointmentFormModal onClose={handleClose} /> : null}
    </Container>
  )
}

export default AppointmentForms
